import { render, staticRenderFns } from "./superSerialPack3.vue?vue&type=template&id=6f1342fa&scoped=true&"
import script from "./superSerialPack3.vue?vue&type=script&lang=js&"
export * from "./superSerialPack3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f1342fa",
  null
  
)

export default component.exports